import type { EventDto } from '../../api/types';

export type UserDayStatus = {
  hasConfirmed: boolean;
  hasPending: boolean;
};

/**
 * Computes user participation statuses per day.
 * Returns a Map with date keys (YYYY-MM-DD) and status flags.
 */
export function computeUserDayStatuses(
  events: EventDto[],
  telegramId: string | undefined
): Map<string, UserDayStatus> {
  const statuses = new Map<string, UserDayStatus>();

  if (!telegramId) return statuses;

  for (const event of events) {
    if (event.status !== 'active') continue;

    const dateKey = event.startAt.slice(0, 10); // YYYY-MM-DD

    for (const p of event.participants) {
      if (p.telegramId === telegramId) {
        let status = statuses.get(dateKey);
        if (!status) {
          status = { hasConfirmed: false, hasPending: false };
          statuses.set(dateKey, status);
        }
        if (p.status === 'confirmed') status.hasConfirmed = true;
        if (p.status === 'pending') status.hasPending = true;
      }
    }
  }

  return statuses;
}
